import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { Observable } from 'rxjs';
import { MasterService } from 'src/app/core/services/master.service';
import { ROOT_COMPANY_ID } from '../constants/constants';
import { Apps } from '../enums/enums';

@Injectable({
  providedIn: 'root',
})
export class AuthguardGuard {
  constructor(
    private masterService: MasterService,
    private router: Router,
    private permissionsService: NgxPermissionsService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const publicRoutes = ['/shared/reset-password', '/shared/complete-account-setup'];
    if (publicRoutes.some((p) => state.url.startsWith(p))) {
      return true;
    }

    const user = this.masterService.getUserDetailFromStorage();
    if (!user) {
      this.router.navigate(['/shared/login']);
      return false;
    }

    const requiredPermission = route.data['permission'];
    if (requiredPermission === 'General') {
      return true;
    }

    const appId = user.companyid > ROOT_COMPANY_ID ? Apps.CompanyPortal : Apps.AdminPortal;
    return this.masterService.getRolesandPerm(appId).then((permissions) => {
      const userPermissions = permissions.map((p) => p.name);

      this.permissionsService.loadPermissions(userPermissions);
      if (
        user.companyid == ROOT_COMPANY_ID &&
        state.url.includes('/admin-portal') &&
        ['User:View', 'Role:View'].includes(requiredPermission)
      ) {
        return userPermissions.includes('User:View') || userPermissions.includes('Role:View');
      }

      const requiredPermissions = Array.isArray(requiredPermission)
        ? requiredPermission
        : [requiredPermission];

      const hasAllPermissions = requiredPermissions.every((rp) => userPermissions.includes(rp));

      if (hasAllPermissions) {
        return true;
      }

      const redirectPath =
        user.companyid > ROOT_COMPANY_ID ? '/home' : '/admin-portal/admin-dashboard';
      this.router.navigate([redirectPath]);
      return false;
    });
  }
}
